export class Product {
	id: number;
    active: boolean;
    ean: string;
    sku: string;
    reference: string;
    price_incl: number;
    price_excl: number;
    advice_price_incl: number;
    advice_price_excl: number;
    purchase_price_excl: number;
    price_valuta: string;
    tax_rate_class_id: number;
    // shippingcost_id: number;
    is_bio: boolean;
    is_new: boolean;
    is_highlighted: boolean;
    is_featured: boolean;
    sale_active: boolean;
    sale_type: string;
    sale_amount: number;
    region_id: number;
    color_id: number;
    winery_id: number;
    tastetype_id: number;
    appellation_id: number;
    volume_id: number;
    backorder: boolean;
    sort_order: number;
    video_url: string;
    source_url: string;
    
    name_nl: string;
    short_description_nl: string;
    description_nl: string;
    alias_nl: string;
    name_en: string;
    short_description_en: string;
    description_en: string;
    alias_en: string;
    name_fr: string;
    short_description_fr: string;
    description_fr: string;
    alias_fr: string;
    name_de: string;
    short_description_de: string;
    description_de: string;
    alias_de: string;

    created_at: string;
    updated_at: string;

    grapes: ProductGrape[];
}

export class ProductGrape {
    id: number;
    percentage: number;
}

export class ProductShort {
	id: number;
    active: boolean;
	name_nl: string;
	alias_nl: string;
	price_incl: number;
    price_excl: number;
}




// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/product.ts